// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2w5Qn","right":"Footer_right__1S76_","buttons":"Footer_buttons__3P3Mk"};